<div class="questionnarie-container">
  <form fxLayout="column"
        [formGroup]="questionForm">
    <!--Questionnarie create information-->

    <div class="q-container">

      <!-- Question form -->
      <div formArrayName="questions"
           *ngIf="questionForm.get('questions')?.value?.length > 0"
           cdkDropList
           (cdkDropListDropped)="dragQuestion($event)">
        <mat-card *ngFor="let question of questionForm.get('questions').controls; let i = index;let first = first;let last = last;"
                  formGroupName="{{i}}"
                  class="q-mat-card"
                  cdkDrag>

          <div>
            <!--card top icon-->
            <div class="q-mt-icon">
              <mat-icon (click)="deleteQuestion(i)"
                        class="question-action-icon"
                        [svgIcon]="'bb_icon_grid_delete'">
              </mat-icon>
              <mat-icon *ngIf="!first"
                        (click)="dragUp(i)"
                        class="question-action-icon"
                        [svgIcon]="'bb_icon_up_arrow'">
              </mat-icon>
              <mat-icon *ngIf="!last"
                        (click)="dragDown(i)"
                        class="question-action-icon"
                        [svgIcon]="'bb_icon_down_arrow'">
              </mat-icon>
            </div>

            <div class="question-inner-box">
              <div fxLayout="row wrap"
                   fxLayout.xs="column"
                   fxLayoutGap="4%"
                   fxLayoutGap.lt-md="0%">
                <div fxFlex="68%;"
                     fxFlex.xs="100%">
                  <!--Required toggle-->
                  <span class="q-required">
                    <mat-slide-toggle formControlName="isRequired">Required</mat-slide-toggle>
                  </span>
                  <label class="q-title-label requiredfield">Question Title</label>
                  <div class="q-title-field">
                    <h6 class="q-sno">{{ i + 1 }}.</h6>
                    <mat-form-field class="full-width"
                                    appearance="outline">
                      <input matInput
                             type="text"
                             formControlName="questionTitle"
                             name="question-title" />
                    </mat-form-field>
                    <small *ngIf="question.get('questionTitle').hasError('required') && question.get('questionTitle').touched && !question.get('questionTitle').hasError('whitespace')"
                           class="form-error-msg">Question Title is required </small>
                    <small *ngIf="question.get('questionTitle').hasError('whitespace') && question.get('questionTitle').touched"
                           class="form-error-msg">Question Title is required </small>
                  </div>
                  <div fxLayout="row"
                       fxLayoutAlign="space-between center">
                    <!--Answers label-->
                    <div>
                      <label class="q-title-label requiredfield marginLeft30">Answers</label>
                    </div>
                    <!--Choice multiple answer -->
                    <div>
                      <span class="q-required"
                            *ngIf="question.get('questionType')?.value === 'choice'">
                        <mat-slide-toggle formControlName="isMultiple">Multiple Answer</mat-slide-toggle>
                      </span>
                    </div>
                  </div>

                  <!--Text-->
                  <div class="q-title-field"
                       *ngIf="question.get('questionType')?.value === 'text'">
                    <mat-form-field class="full-width"
                                    appearance="outline">
                      <input matInput
                             type="text"
                             readonly
                             placeholder="Enter Your answer" />
                    </mat-form-field>
                  </div>

                  <!-- <br /> -->

                  <div formArrayName="options"
                       *ngIf="question.get('questionType')?.value === 'choice' && question.get('options')?.value?.length > 0"
                       cdkDropList
                       (cdkDropListDropped)="drop($event, i)">
                    <div *ngFor="let option of question.get('options').controls; let optionIndex = index"
                         formGroupName="{{optionIndex}}">
                      <div cdkDrag
                           fxLayout="column"
                           fxLayout.xs="column">
                        <div fxFlex="100%;"
                             fxFlex.xs="100%">
                          <div class="q-option-container">
                            <div *ngIf="question.get('isMultiple')?.value == false"
                                 class="q-radio">
                              <div fxLayout="row wrap"
                                   fxLayout.xs="column">
                                <div class="option-radio-icon"
                                     fxFlex="5%;"
                                     fxFlex.xs="100%">
                                  <mat-icon class="radio-icon"
                                            [svgIcon]="'bb_icon_radio'"></mat-icon>
                                </div>
                                <div fxFlex="90%;"
                                     fxFlex.xs="100%">
                                  <mat-form-field class="full-width padding5 qustionAnswer"
                                                  appearance="outline">
                                    <input matInput
                                           type="text"
                                           formControlName="name" />
                                  </mat-form-field>
                                  <small *ngIf="option.get('name').hasError('required') && option.get('name').touched && !option.get('name').hasError('whitespace')"
                                         class="form-error-msg marginLeft5">Answer is required </small>
                                  <small *ngIf="option.get('name').hasError('whitespace') && option.get('name').touched"
                                         class="form-error-msg marginLeft5">Answer is required </small>

                                </div>
                                <div class="option-del-icon"
                                     fxFlex="5%;"
                                     fxFlex.xs="100%">
                                  <mat-icon class="delete-icon"
                                            *ngIf="question.get('options').length>1"
                                            [svgIcon]="'bb_icon_grid_delete'"
                                            (click)="deleteOption(i, optionIndex)"></mat-icon>
                                </div>
                              </div>
                            </div>

                            <!--Checkbox for selecet multiple answer-->
                            <div *ngIf="question.get('isMultiple')?.value == true"
                                 class="q-radio width100">
                              <div fxLayout="row wrap"
                                   fxLayout.xs="column">
                                <div class="option-radio-icon"
                                     fxFlex="5%;"
                                     fxFlex.xs="10%">
                                  <mat-icon class="radio-icon"
                                            [svgIcon]="'bb_icon_checkbox'"></mat-icon>
                                </div>
                                <div fxFlex="90%;"
                                     fxFlex.xs="10%">
                                  <mat-form-field class="full-width padding5 noMarginB"
                                                  appearance="outline">
                                    <input matInput
                                           type="text"
                                           formControlName="name" />
                                  </mat-form-field>
                                  <small *ngIf="option.get('name').hasError('required') && option.get('name').touched && !option.get('name').hasError('whitespace')"
                                         class="form-error-msg marginLeft5"><br />Answer is required </small>
                                  <small *ngIf="option.get('name').hasError('whitespace') && option.get('name').touched"
                                         class="form-error-msg marginLeft5"><br />Answer is required </small>
                                </div>
                                <div class="option-del-icon"
                                     fxFlex="5%;"
                                     fxFlex.xs="100%">
                                  <mat-icon class="delete-icon"
                                            *ngIf="question.get('options').length>1"
                                            [svgIcon]="'bb_icon_grid_delete'"
                                            (click)="deleteOption(i, optionIndex)"></mat-icon>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="q-options-btn"
                       *ngIf="question.get('questionType')?.value === 'choice'">
                    <div (click)="addOptions(i)">
                      <img class="q-options-icon cursorPointer"
                           src="../../../../../assets/bbraun/common/plus.png"
                           alt="plus-icon" />
                      <span class="q-options-label">Answer Options</span>
                    </div>
                  </div>
                  <!--Rating   *ngIf="question.get('questionType')?.value === 'netPromoterScore'"-->
                  <div class="q-title-field"
                       *ngIf="question.get('questionType')?.value === 'rating'">
                    <button *ngFor="let star of [0, 1, 2, 3, 4]; let i = index"
                            class="rating-button"
                            type="button">
                      <img src="../../../../../assets/bbraun/common/star.png" alt="star-icon"/>
                    </button>
                  </div>

                  <div *ngIf="question.get('questionType')?.value === 'netPromoterScore'"
                       class="q-title-field">
                    <div class="promoterScore"
                         *ngFor="let star of [0, 1, 2, 3, 4,5,6,7,8,9,10]; let i = index">
                      {{i}}
                    </div>
                    <div fxLayout="row wrap"
                         fxLayout.xs="column">
                      <div fxFlex="50%;"
                           fxFlex.xs="100%">
                        <div class="width70">
                          <mat-form-field class="full-width"
                                          appearance="outline">
                            <input matInput
                                   type="text"
                                   formControlName="promoterTitleFrom"
                                   name="question-title" />
                          </mat-form-field>
                          <small *ngIf="question.get('promoterTitleFrom').hasError('required') && question.get('promoterTitleFrom').touched"
                                 class="form-error-msg">Required </small>
                        </div>

                      </div>
                      <div fxFlex="50%;"
                           fxFlex.xs="100%"
                           fxLayoutAlign="end end">
                        <div class="width70">
                          <mat-form-field class="full-width"
                                          appearance="outline">
                            <input matInput
                                   type="text"
                                   formControlName="promoterTitleTo"
                                   name="question-title" />
                          </mat-form-field>
                          <small *ngIf="question.get('promoterTitleTo').hasError('required') && question.get('promoterTitleTo').touched"
                                 class="form-error-msg">Required </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div fxFlex="28%;"
                     fxFlex.xs="100%"
                     class="paddingT32">
                  <div *ngIf="!questionDetails || !questionDetails[i]||questionDetails.questions[i].fileLocation==''">
                    <label id="file-label">Image Upload</label>
                    <div *ngIf="!uploadedFiles[i]"
                         class="fileUpload"
                         appFileDragDrop
                         (onFileDropped)="handleFileUpload($event, i)">
                      <button #upload
                              mat-raised-button
                              type="button"
                              (click)="file.click()"
                              color="primary"
                              class="browse-btn">
                        <img src="./assets/bbraun/common/file-upload.svg"
                             alt="icon" />
                        Browse
                      </button>
                    </div>
                    <div class="cardBG mt-2"
                         *ngIf="uploadedFiles[i]&&(!questionDetails || !questionDetails[i]||questionDetails.questions[i].fileLocation=='')&&uploadedFiles[i].url">
                      <div fxLayout="row wrap"
                           fxLayout.xs="column">
                        <div class="documenticon">
                          <img src="./assets/bbraun/manageEvent/image-icon.svg"
                               class="width40"
                               alt="icon" />
                        </div>
                        <div class="documentDetail">
                          <span class="documentName">{{uploadedFiles[i].name}}</span>
                        </div>
                        <div class="documentClose">
                          <img src="./assets/bbraun/common/close-icon.svg"
                               class="width40"
                               (click)="removeFileUpload(i)"
                               alt="icon" />
                        </div>
                      </div>
                      <div fxLayout="row wrap"
                           fxLayout.xs="column"
                           *ngIf="uploadedFiles[i].url">
                        <!-- <div class="documenticon">
                          <img src="./assets/bbraun/manageEvent/image-icon.svg"
                               class="width40"
                               alt="icon" />
                        </div> -->
                        <div class="documentDetail">
                          <!-- <span class="documentName">{{uploadedFiles[i]}}</span> -->
                          <img src="{{uploadedFiles[i].url}}"
                               class="questionImage"
                               alt="icon" />
                        </div>
                        <div class="documentClose">
                          <!-- <img src="./assets/bbraun/common/close-icon.svg"
                               class="width40"
                               (click)="removeFileUpload(i)"
                               alt="icon" /> -->
                          <span class="clearImage "
                                (click)="removeFileUpload(i)">Clear</span>
                        </div>
                      </div>
                    </div>
                    <input type="file"
                           #file
                           class="hideInput"
                           hidden
                           (change)="handleFileUpload($event, i)" />
                  </div>
                  <div
                       *ngIf="questionDetails && questionDetails.questions[i] && questionDetails.questions[i].fileLocation">
                    <img [src]="questionDetails.questions[i].fileLocation"
                         class="questionImage"
                         alt="icon" />
                    <span class="clearImage "
                          (click)="removeFileUpload(i)">Clear</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </mat-card>
      </div>

      <!-- Question form -->

      <!--Button -->

      <button mat-raised-button
              class="create-btn questionButton"
              (click)="addNewQuestion()"
              type="button">
        <img src="../../../../../assets/bbraun/common/plus-icon.svg"
             class="width4" alt="plus-icon"/>

        <div class="questionType radiusLeft"
             (click)="getQuestionType('choice')"
             readonly
             id="clickId"
             value="choice">
          <mat-icon class="width25"
                    [svgIcon]="'bb_icon_radio_checked'"></mat-icon> Choice
        </div>
        <div class="questionType"
             (click)="getQuestionType('text')"
             id="clickId"
             value="text">
          <mat-icon class="borderLeft width25"
                    [svgIcon]="'bb_icon_text_answer'"></mat-icon> Text Answer
        </div>
        <div class="questionType"
             (click)="getQuestionType('rating')"
             id="clickId"
             value="rating">
          <mat-icon class="borderLeft width25"
                    [svgIcon]="'bb_icon_star'"></mat-icon> Rating
        </div>
        <div class="questionType radiusRight"
             (click)="getQuestionType('netPromoterScore')"
             id="clickId"
             value="netPromoterScore">
          <mat-icon class="borderLeft width25"
                    [svgIcon]="'bb_icon_net_promoter'"></mat-icon> Net Promoter Score
        </div>
      </button>
    </div>
  </form>
</div>